module.exports = function getResource(label, vars = []) {
    let resources = {
        defaultCard: 'Carte par défaut',
        expires: 'Expire le',
        payPalAccount: 'Compte PayPal',
        payWithPayPal: 'Payer avec PayPal',
        payWithApplePay: 'Payer avec ApplePay',
        payWithKlarna: 'Payez en quatre versements sans intérêt',
        storeCreditApplied: 'Crédit au compte appliqué',
        endingIn: 'terminant par',
        klarnaDisabled: `${vars[0]} ne peut pas être utilisée pour les achats de cartes-cadeaux, de Flash, d’abonnements ou de rendez-vous en magasin, pour les récompenses Carte de crédit Sephora, ni pour les commandes de 1 000 $ ou plus.`
    };

    return resources[label];
};
